export default __webpack_public_path__ + "locales/sl/DataReassignmentDialog.json?hash=27dd23b93cf945adffa59b88f5c9a060";